/*** IMPORTS FROM imports-loader ***/
var define = false;

require('./_set-species')('Array');

